import React from "react";
import { Alert, Table } from "reactstrap";
import { useQuery } from "react-query";
import { useClient } from "../../../../hooks";
import { ConfirmButton } from "../../components/ConfirmButton";
import { NotificationManager } from "react-notifications";
import { formatDateTime } from "../../util";
import { get } from "lodash";

const DBSContact = ({ application, onSent }) => {
  const baseUrl = `volunteer_applications/${application}`;
  const dbsContactQueryKey = [`${baseUrl}/dbs_contact`];
  const client = useClient();
  const { data: dbsContact } = useQuery(dbsContactQueryKey, () =>
    client.get(...dbsContactQueryKey).get("data")
  );

  if (!dbsContact) return null;

  const { organisation_name, dbs_contact_name, dbs_contact_email } = dbsContact;

  async function onSend() {
    await client.post(`${baseUrl}/send_dbs_form`);
    NotificationManager.success("Email sent");

    if (onSent) {
      onSent();
    }
  }

  if (!dbs_contact_name || !dbs_contact_email) {
    return (
      <Alert color="warning">
        {organisation_name} requires DBS/PVG/Access NI contact name and email details.
      </Alert>
    );
  }

  return (
    <div>
      <p>
        The DBS/PVG/Access NI contact for {organisation_name} is{" "}
        <strong>{dbs_contact_name}</strong> (
        <strong>{dbs_contact_email}</strong>).
      </p>
      <ConfirmButton
        onClick={onSend}
        confirmProps={{
          color: "warning",
          children: (
            <>
              <span className="fa fa-envelope mr-2" /> Confirm send check email?
            </>
          ),
        }}
      >
        <span className="fa fa-envelope mr-2" /> Send check email
      </ConfirmButton>
    </div>
  );
};

export const DBS = ({ application, onChanged }) => {
  const { id, dbs_form } = application;
  const client = useClient();

  if (!dbs_form) {
    return <DBSContact onSent={onChanged} application={id} />;
  }

  const { name, email, confirmed__label, submitted, email_sent } = dbs_form;
  const baseUrl = `volunteer_applications/${id}`;

  async function onResend() {
    try {
      await client.post(`${baseUrl}/resend_dbs_form`);
    } catch (ex) {
      const code = get(ex, "response.data.code");

      if (code === "name_or_email_missing") {
        NotificationManager.error(
          "DBS/PVG/Access NI contact name or email missing from organisation"
        );
        return;
      } else {
        throw ex;
      }
    }

    NotificationManager.success("Email sent");
    await onChanged();
  }

  return (
    <Table size="sm">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th></th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{name}</td>
          <td>{email}</td>
          <td>
            <ul className="pl-0 tw-list-none text-muted">
              <li>
                {email_sent ? (
                  <>
                    <span className="fa fa-check-circle text-success" /> email
                    sent on <strong>{formatDateTime(email_sent)}</strong>
                  </>
                ) : (
                  <>
                    <span className="fa fa-times-circle text-danger" /> email
                    not sent
                  </>
                )}
              </li>
              <li>
                {submitted ? (
                  <>
                    <span className="fa fa-check-circle text-success" /> form
                    submitted on <strong>{formatDateTime(submitted)}</strong>{" "}
                    with <strong>{confirmed__label}</strong> option
                  </>
                ) : (
                  <>
                    <span className="fa fa-times-circle text-danger" /> form not
                    submitted
                  </>
                )}
              </li>
            </ul>
          </td>
          <td>
            <ConfirmButton
              size="sm"
              onClick={onResend}
              confirmProps={{
                color: "warning",
                children: (
                  <>
                    <span className="fa fa-envelope mr-2" /> Confirm send?
                  </>
                ),
              }}
            >
              <span className="fa fa-envelope mr-2" /> Resend email
            </ConfirmButton>
          </td>
        </tr>
      </tbody>
    </Table>
  );
};
